import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-coupon';

// 当过滤时间为指定时,删除对象中的值
const checkDate = (data, lintDate, ...params) => {
	params.forEach((item) => {
		if (data[item] === lintDate) {
			delete data[item];
		}
	});
};

const memberCouponList = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/coupons`, data);
};

const couponsList = (merchantId, data) => {
	checkDate(
		data,
		'1970/01/01 00:00:00',
		'provideStartDate',
		'provideEndDate',
		'useEndDate',
		'useStartDate'
	);
	return Client.get(`${baseUrl}/${merchantId}/coupons`, data);
};

const couponDetail = (merchantId, couponId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/coupons/${couponId}`, data);
};

const couponSchema = (merchantId, scopeId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/scope-schemas/${scopeId}`, data);
};

const couponSchemaItems = (merchantId, scopeId) => {
	return Client.get(`${baseUrl}/${merchantId}/scope-schema-items/${scopeId}`);
};

const putCouponSchemaItems = (merchantId, scopeId, data) => {
	return Client.put(
		`${baseUrl}/${merchantId}/scope-schema-items/${scopeId}`,
		data
	);
};

const couponIssueList = (merchantId, data) => {
	checkDate(data, '1970/01/01 00:00:00', 'provideEndTime', 'provideStartTime');
	return Client.get(`${baseUrl}/${merchantId}/provides`, data);
};

const getCouponIssue = (merchantId, data, providedId) => {
	return Client.get(`${baseUrl}/${merchantId}/provides/${providedId}`, data);
};

const couponScopeSchemasList = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/scope-schemas`, data);
};

const addCouponIssue = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/provides`, data);
};

const updateCouponIssue = (merchantId, data, providedId) => {
	return Client.put(`${baseUrl}/${merchantId}/provides/${providedId}`, data);
};

const couponScopeSchemaTargets = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/scope-schema-targets`, data);
};

const addMangageCoupon = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/scope-schemas`, data);
};

const putManageCoupon = (merchantId, scopeId, data) => {
	return Client.put(`${baseUrl}/${merchantId}/scope-schemas/${scopeId}`, data);
};

const couponsExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/coupons/export`, data, {
		responseType: 'blob',
	});
};

export default {
	memberCouponList,
	couponsList,
	couponDetail,
	couponSchema,
	couponSchemaItems,
	putCouponSchemaItems,
	couponIssueList,
	getCouponIssue,
	couponScopeSchemasList,
	addCouponIssue,
	updateCouponIssue,
	couponScopeSchemaTargets,
	addMangageCoupon,
	putManageCoupon,
	couponsExport,
};
